<div class="ir-item-line th-filter" *ngIf="items?.length">
  <div class="ir-item-cell s4 clickable" (click)="setOrderBy('name')">
    <span>
      <i class="material-icons" *ngIf="direction === 'asc'">arrow_drop_up</i>
      <i class="material-icons" *ngIf="direction === 'desc'">arrow_drop_down</i>
      {{ 'common.name' | translate }}
    </span>
  </div>
  <div class="ir-item-cell s4 clickable" (click)="setOrderBy('location')">
    <span>
      <i class="material-icons" *ngIf="direction === 'asc'">arrow_drop_up</i>
      <i class="material-icons" *ngIf="direction === 'desc'">arrow_drop_down</i>
      {{ 'inspections.restore-items.location' | translate }}
    </span>
  </div>
  <div class="ir-item-cell s2 clickable" (click)="setOrderBy('deletionDate')">
    <span>
      <i class="material-icons" *ngIf="direction === 'asc'">arrow_drop_up</i>
      <i class="material-icons" *ngIf="direction === 'desc'">arrow_drop_down</i>

      {{ 'inspections.restore-items.deletionDate' | translate }}
    </span>
  </div>
</div>

<div class="ir-item-empty ir-mv8" *ngIf="items?.length == 0">
  <p>
    <span>{{ 'inspections.restore-items.no-items' | translate }}</span>
  </p>
</div>
<div class="ir-content-flow" *ngIf="items?.length > 0" [ngClass]="items?.length > 0 ? 'has-filter' : ''">
  <div *ngFor="let item of items | orderBy: orderByFieldName:direction | searchBy: query">
    <div class="ir-item-line th-point clickable, indent">
      <div class="ir-item-cell s4">
        <div class="ir-item-selector" (click)="selectItem($event, item)">
          <i class="material-icons" *ngIf="!item.selected">check_box_outline_blank</i>
          <i class="material-icons" *ngIf="item.selected">check_box</i>
        </div>
        <span>{{ item.name }}</span>
      </div>
      <div class="ir-item-cell s4">
        <span>{{ item.location }}</span>
      </div>
      <div class="ir-item-cell s2">
        <span>{{ item.deletionDate | formatDate }}</span>
      </div>
    </div>
  </div>
</div>
